import { useContext, useMemo } from "react";
import { GeaoContext } from "../../../GeaoContextProvider";

export default function useMappers(formData) {
    const { agencyInterview } = useContext(GeaoContext);

    const agencyAnswers = useMemo(() => {
        if (!formData) return null;

        return {
            CurrentLinesOfBusinessPersonal: { answer: formData.currentLinesOfBusinessPersonal.toString() },
            CurrentLinesOfBusinessCommercial: { answer: formData.currentLinesOfBusinessCommercial.toString() },
            CurrentLinesOfBusinessHome: { answer: formData.currentLinesOfBusinessHome.toString() },
            CurrentLinesOfBusinessHealth: { answer: formData.currentLinesOfBusinessHealth.toString() },
            CurrentLinesOfBusinessOther: { answer: formData.currentLinesOfBusinessOther.toString() },
            CurrentLinesOfBusinessOtherText: { answer: formData.currentLinesOfBusinessOtherText },
            TotalEmployees: { answer: formData.totalEmployees.toString() },
            UnlicensedAgents: { answer: formData.unlicensedAgents.toString() },
            PersonalLinesDirectCarrierAppointments: { answer: formData.personalLinesDirectCarrierAppointments.toString() },
            LicensedAgentsPersonalLines: { answer: formData.licensedAgentsPersonalLines.toString() },
            CommercialLinesDirectCarrierAppointments: { answer: formData.commercialLinesDirectCarrierAppointments.toString() },
            LicensedAgentsCommercialLines: { answer: formData.licensedAgentsCommercialLines.toString() },
            LicensedAgentsCombination: { answer: formData.licensedAgentsCombination.toString() },
            LicensedAgentsOtherLines: { answer: formData.licensedAgentsOtherLines.toString() }
        };
    }, [formData]);

    const defaultValues = useMemo(() => {
        return {
            currentLinesOfBusinessPersonal: agencyInterview?.questionAnswers?.CurrentLinesOfBusinessPersonal?.answer === "true",
            currentLinesOfBusinessCommercial: agencyInterview?.questionAnswers?.CurrentLinesOfBusinessCommercial?.answer === "true",
            currentLinesOfBusinessHome: agencyInterview?.questionAnswers?.CurrentLinesOfBusinessHome?.answer === "true",
            currentLinesOfBusinessHealth: agencyInterview?.questionAnswers?.CurrentLinesOfBusinessHealth?.answer === "true",
            currentLinesOfBusinessOther: agencyInterview?.questionAnswers?.CurrentLinesOfBusinessOther?.answer === "true",
            currentLinesOfBusinessOtherText: agencyInterview?.questionAnswers?.CurrentLinesOfBusinessOtherText?.answer ?? "",
            totalEmployees: agencyInterview?.questionAnswers?.TotalEmployees?.answer,
            unlicensedAgents: agencyInterview?.questionAnswers?.UnlicensedAgents?.answer,
            personalLinesDirectCarrierAppointments: agencyInterview?.questionAnswers?.PersonalLinesDirectCarrierAppointments?.answer,
            licensedAgentsPersonalLines: agencyInterview?.questionAnswers?.LicensedAgentsPersonalLines?.answer,
            commercialLinesDirectCarrierAppointments: agencyInterview?.questionAnswers?.CommercialLinesDirectCarrierAppointments?.answer,
            licensedAgentsCommercialLines: agencyInterview?.questionAnswers?.LicensedAgentsCommercialLines?.answer,
            licensedAgentsCombination: agencyInterview?.questionAnswers?.LicensedAgentsCombination?.answer,
            licensedAgentsOtherLines: agencyInterview?.questionAnswers?.LicensedAgentsOtherLines?.answer
        };
    }, [agencyInterview]);

    return {
        agencyAnswers,
        defaultValues
    }
}